import goBind from '@/views/goBind/goBind'
import editUserInfo from '@/views/goBind/editUserInfo'
import editResult from '@/views/goBind/editResult'
import improveUserInfo from '@/views/goBind/improveUserInfo'

import Vue from 'vue'

export default [
  {
    path: '/goBind',
    name: 'goBind',
    component: goBind,
    meta: {
      title: '个人信息',
      requireAuth: false,
      requireUserInfo: true
    },
  },
  {
    path: '/editUserInfo',
    name: 'editUserInfo',
    component: editUserInfo,
    meta: {
      title: '编辑个人信息',
      requireAuth: false,
    }
  },
  {
    path: '/editResult',
    name: '',
    component: editResult,
    meta: {
      title: '编辑个人信息',
      requireAuth: false,
    }
  },
  {
    path: '/improveUserInfo',
    name: '',
    component: improveUserInfo,
    meta: {
      title: '编辑个人信息',
      requireAuth: false,
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/bindInfo.js